import React from "react";
import moment from "moment";

import { Popover, OverlayTrigger } from "react-bootstrap";
import { Button, TileTitle, Tile, TileBody, TileItem } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faExclamationTriangle, faBan } from "@fortawesome/free-solid-svg-icons";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import deploymentsIcon from "images/tileIcons/deployments.svg";
import arrowIcon from "images/tileIcons/arrow.svg";

import imageMonitoringLight from "images/consumeHeader/monitoring-light.svg";

import getStyles from "components/Home/Utils/getStyles";
import {
  InfoItem,
  TypeIcon,
  InfoIcon,
  Icon,
  NumberDisplay,
  ErrorOverlay,
  DeleteButton
} from "components/Home/Utils/Utils";

import styles from "./style.module.css";

const deploymentStyles = getStyles("deployment");

export default class DeploymentTile extends React.PureComponent {
  state = {
    recipeStatus: "NotStarted",
    isHover: false
  };

  handleOnClick(event, mode) {
    const { onHover, onClick } = this.props;

    onHover && onHover(undefined);
    return onClick && onClick(event, mode);
  }

  handleDelete(event) {
    event.stopPropagation();
    const { handleDelete, onHover } = this.props;

    if (handleDelete) {
      onHover && onHover(undefined);
      return handleDelete(event);
    } else return;
  }

  handleCancel(event) {
    event.stopPropagation();
    const { handleCancel } = this.props;

    if (handleCancel) {
      return handleCancel();
    } else return;
  }

  getDeployLabel() {
    const { deployRecipeId, hasDeployedRecipe } = this.props;

    if (deployRecipeId === undefined) {
      return "Endpoint URL";
    }

    switch (this.state.recipeStatus) {
      case "Executing":
        return "Deploying Recipe...";

      case "Terminating":
        return "Terminating Recipe...";

      default:
        if (hasDeployedRecipe) {
          return "Terminate Recipe";
        } else {
          return "Deploy Recipe";
        }
    }
  }

  isUpdatingRecipe() {
    switch (this.state.recipeStatus) {
      case "Executing":
      case "Terminating":
        return true;

      default:
        return false;
    }
  }

  render() {
    const {
      deployment,
      isCreate,
      isFirst,
      isHighlight,
      isSmall,
      onClick,
      noClick,
      onHover,
      noHover,
      handleDelete,
      handleCancel,
      deployRecipeId,
      handleDeployRecipe,
      deployedRecipeName,
      handleTerminateRecipeDeployment,
      shouldHighlight,
      hasDeployedRecipe,
      hideDelete,
      monitor,
      job,
      noPermissions,
      isConsumer
    } = this.props;

    if (isCreate || isFirst) {
      return <CreateDeploymentTile onClick={onClick} />;
    }

    if (!deployment) {
      return isConsumer ? (
        <div
          style={{
            height: 250,
            width: 240,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "13px"
          }}
        >
          {"Project not Deployed"}
        </div>
      ) : (
        <React.Fragment></React.Fragment>
      );
    }

    const annotations = deployment.annotations && deployment.annotations.filter((a) => a.type === "info");

    const errors = deployment.annotations && deployment.annotations.filter((a) => a.type === "error");

    const isError = (errors && errors.length > 0) || deployment.status === "ERROR";

    const isDone = deployment.status === "RUNNING" || deployment.status === "ERROR";

    const isLoading = !isDone && !isError;

    const hasDeployRecipe = deployRecipeId !== undefined;

    // if (monitor && monitor.id) {
    //   if (monitor.status !== "DONE" && monitor.status !== "ERROR") {
    //     triggerText = <h3 className={deploymentStyles.text}>{"Loading Monitoring..."}</h3>;
    //   } else {
    //     if (monitor.impactData && monitor.impactData.length) {
    //       const style = {borderRadius: "4px"};
    //       const monitorDifference = monitor.impactData && monitor.impactData.length && monitor.impactData[monitor.impactData.length - 1] && monitor.impactData[monitor.impactData.length - 1].OverallRelative;
    //       const monitorStart = monitor.impactData && monitor.impactData.length && monitor.impactData[0] && monitor.impactData[0].date;
    //       const monitorEnd = monitor.impactData && monitor.impactData.length && monitor.impactData[monitor.impactData.length - 1] && monitor.impactData[monitor.impactData.length - 1].date;
    //       if (monitorDifference < 0) {
    //         style.transform = "scaleY(-1)";
    //       }
    //       const startMoment = moment.unix(monitorStart);
    //       const endMoment = moment.unix(monitorEnd);
    //       triggerImg = <Icon color={deploymentStyles.color} src={arrowIcon} style={style}/>;
    //       triggerText = (<React.Fragment>
    //         <div className={styles.tileTriggerTextRow}>
    //           <h3 className={deploymentStyles.text}>{(monitorDifference >= 0 ? "+" : "") + monitorDifference + "%"}</h3>
    //         </div>
    //         {monitorStart && monitorEnd ? <div className={styles.tileTriggerTextRow}>
    //           <p className={deploymentStyles.text}>{"over " + endMoment.from(startMoment, true)}</p>
    //         </div> : ""}
    //       </React.Fragment>);
    //     } else {
    //       triggerText = <h3 className={deploymentStyles.text}>{"No Monitoring Data"}</h3>;
    //     }
    //   }
    // } else {
    //   triggerImg = <div className={styles.deploymentNoMonitoring}>{"N/A"}</div>;
    //   triggerText = <p style={{color: "#A4A6B7"}}>{"Monitoring Not Loaded"}</p>;
    // }

    let title = deployment.label || "";
    let overlayText = deployment.label + " (" + (deployment.project_id || deployment.id) + ")";
    if (job && job.name) {
      title = job.name + ": " + title;
      overlayText = job.name + (job.id ? " (" + job.id + "): " : ": ") + overlayText;
    }

    let buttonText = "View Deployment";
    let errorText = "";
    if (noPermissions) {
      errorText = "You don't have permission to access this deployment";
    } else if (isError) {
      buttonText = "Retry";
      errorText =
        "We encountered an error while deploying the " +
        (deployment.project_id ? "project" : hasDeployRecipe ? "recipe" : "model") +
        ".";
    } else {
      buttonText = isConsumer ? "View Monitoring" : "View Deployment";
      errorText = "";
    }

    const isNext = true;

    return (
      <Tile
        onClick={onClick && !noPermissions ? (e) => this.handleOnClick(e, "d") : undefined}
        onMouseEnter={() => {
          onHover && onHover(deployment.id);
          return this.setState({ isHover: true });
        }}
        onMouseLeave={() => {
          onHover && onHover(undefined);
          return this.setState({ isHover: false });
        }}
        buttonText={buttonText}
        handleDelete={handleDelete && !noPermissions ? (e) => this.handleDelete(e) : undefined}
        active={isHighlight}
        noHover={noHover}
        shouldHighlight={shouldHighlight}
        hideDelete={hideDelete}
      >
        <TileTitle
          title={overlayText}
          icon={isConsumer ? "monitoring" : "deployment"}
          color={isLoading || noPermissions ? "default" : "deployment"}
        >
          {title}
        </TileTitle>
        <TileBody
          isLoading={!isNext && isLoading}
          loadingText={"Deploying..."}
          isError={isError || noPermissions}
          errorText={errorText}
          color={isLoading ? "default" : "deployment"}
        >
          {!isNext && !isConsumer && onClick ? (
            <TileItem icon={"layersPurple"} onClick={() => this.handleOnClick("b")}>
              {"View Project"}
            </TileItem>
          ) : (
            ""
          )}
          {!isNext && !isConsumer && deployment.endpoint_url ? (
            <TileItem
              icon={"link"}
              onClick={
                hasDeployRecipe && !this.isUpdatingRecipe()
                  ? (e) => {
                      let promise;
                      let recipeStatus;

                      if (hasDeployedRecipe) {
                        promise = handleTerminateRecipeDeployment(deployment.id);
                        recipeStatus = "Terminating";
                      } else {
                        promise = handleDeployRecipe(deployment.id);
                        recipeStatus = "Executing";
                      }

                      this.setState({ recipeStatus: recipeStatus });

                      promise.then(() => this.setState({ recipeStatus: "Complete" }));
                    }
                  : undefined
              }
              overlayTitle={hasDeployRecipe ? "Recipe" : "Endpoint URL and Headers"}
              overlay={
                <div className={styles.popList}>
                  <div className={styles.oField}>{hasDeployRecipe ? deployedRecipeName : deployment.endpoint_url}</div>
                  {Object.keys(deployment.endpoint_headers || {}).map((key) => (
                    <div key={key} className={styles.oField}>
                      {`${key}: ${deployment.endpoint_headers[key]}`}
                    </div>
                  ))}
                </div>
              }
            >
              {this.getDeployLabel()}
            </TileItem>
          ) : (
            ""
          )}
          <TileItem icon={"user"}>{deployment.created_by && deployment.created_by.fullname}</TileItem>
          <TileItem
            icon={"calendar"}
            overlay={moment.utc(deployment.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
          >
            {moment.utc(deployment.created_date).local().fromNow()}
          </TileItem>
        </TileBody>
      </Tile>
    );
  }
}

export class CreateDeploymentTile extends React.PureComponent {
  render() {
    const { onClick } = this.props;
    const text = "Deployments";
    return (
      <div className={styles.tileWrapper}>
        <div className={onClick ? styles.tile : styles.tileNoHover} onClick={onClick ? () => onClick() : () => {}}>
          <div className={styles.createTileImageWrapper}>
            <div className={styles.createTileIcon}>
              <img src={deploymentsIcon} alt={text} />
            </div>
          </div>
          <div className={styles.createTileBody}>
            <div className={styles.createTileHeader + " " + deploymentStyles.text}>{text}</div>
          </div>
        </div>
      </div>
    );
  }
}
